export default "<app-map></app-map>\n<app-footer></app-footer>\n\n"